import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { HelmetProvider } from 'react-helmet-async';
import "./index.css";
import "./App.css";
import "react-multi-carousel/lib/styles.css";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import "swiper/css/navigation";
import 'swiper/css/effect-creative';
import "swiper/css/scrollbar";
import "react-datepicker/dist/react-datepicker.css"
// import "./assets/font/satoshi-font.css";
import 'react-slideshow-image/dist/styles.css'
import AppRoutes from "./router/AppRoutes";
import { Provider } from "react-redux";
import Store from "./Store"
import { registerServiceWorker, unregisterServiceWorker } from './utils/serviceWorker';
import { validateEnv } from './config/env';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={Store}>
        <AppRoutes />
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
);

// Validation des variables d'environnement
validateEnv();

// Enregistrement du service worker (désactivé en développement si nécessaire)
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else {
  // En développement, vous pouvez désactiver le service worker si nécessaire
  // Décommentez la ligne suivante pour désactiver le service worker en développement
  // unregisterServiceWorker();
  registerServiceWorker();
}

// react-slideshow-image/dist/styles.css